<template>
    <transition :duration="{ enter: 0, leave: 300 }">
        <div v-show="show">
            <div
                class="fixed inset-0 z-50 overflow-y-auto"
                aria-labelledby="new-version-modal-title"
                role="dialog"
                aria-modal="true"
            >
                <div class="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
                    <fade-transition>
                        <div v-show="show" class="fixed inset-0 transition-opacity">
                            <div class="absolute inset-0 opacity-75 overlay-bg"></div>
                        </div>
                    </fade-transition>

                    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
                        &#8203;
                    </span>

                    <modal-transition>
                        <div
                            v-show="show"
                            class="inline-block px-4 pt-5 pb-4 overflow-hidden text-left align-bottom transition-all transform rounded-lg shadow-xl tier-3-bg sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6"
                        >
                            <div class="sm:flex sm:items-start">
                                <div
                                    class="flex items-center justify-center w-12 h-12 mx-auto rounded-full shrink-0 info-svg-bg sm:mx-0 sm:h-10 sm:w-10"
                                >
                                    <svg
                                        class="w-5 h-5 info-svg-text"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                        aria-hidden="true"
                                    >
                                        <path
                                            fill-rule="evenodd"
                                            d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z"
                                            clip-rule="evenodd"
                                        />
                                    </svg>
                                </div>
                                <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                    <h3
                                        id="new-version-modal-title"
                                        class="text-lg font-medium leading-6 tier-3-text-emphasize"
                                    >
                                        {{ $t('new_version.modal.title') }}
                                    </h3>
                                    <div class="mt-2">
                                        <p class="text-sm leading-5 tier-3-text">
                                            {{ $t('new_version.modal.message') }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-5 sm:mt-4">
                                <span class="flex justify-end w-full sm:w-auto">
                                    <primary-button
                                        @click="reload"
                                        class="inline-flex justify-center w-full text-base font-medium leading-6 transition duration-150 ease-in-out sm:w-auto sm:text-sm sm:leading-5"
                                    >
                                        {{ $t('new_version.modal.reload_button') }}
                                    </primary-button>
                                </span>
                            </div>
                        </div>
                    </modal-transition>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import FadeTransition from '@/components/Transitions/Fade.vue';
import ModalTransition from '@/components/Transitions/Modal.vue';
import PrimaryButton from '@/components/ui/UiPrimaryButton.vue';

export default {
    name: 'NewVersionModal',
    components: {
        FadeTransition,
        ModalTransition,
        PrimaryButton,
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        reload() {
            window.location.reload();
        },
    },
};
</script>
